// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bM9y","colBig":"styles_colBig__2cD8A","colSmall":"styles_colSmall__1NAFL","shopifyNameWrapper":"styles_shopifyNameWrapper__10LlY"};